const checkMobile = (): boolean => !!/mobile/i.test(navigator.userAgent);

export default checkMobile;
